
export enum StyleComboType {
	ChainWin,
	Idle,
	DamageTaken
}
